import { useIntl } from 'react-intl';
import { useFeatureUser } from 'sonata-react-components';

import { DeviatedLineItemsTab } from '@/components/campaigns/DeviatedLineItemsTab';
import { buildDeviatedLineItemsRequestBody } from '@/components/campaigns/DeviatedLineItemsTab/deviatedLineItemsTab.helpers';
import { DeviatedLineItemsCount } from '@/components/campaigns/SummaryBar/DeviatedLineItemsCount';
import { DeviatedLineItemsStats } from '@/components/campaigns/SummaryBar/DeviatedLineItemsStats';
import { Main } from '@/components/common/Main';
import { useGlobalStore } from '@/store/global';
import { getSessionByKeys } from '@/store/global/session/selectors';
import {
  CampaignsStore,
  createStore,
  getPersistedCampaignsFiltersForUser,
  Provider,
  useStore as useCampaignStore
} from '@/store/local/campaigns';

import './deviatedLineItemsPage.scss';

function DeviatedLineItemsPageContent() {
  const { formatMessage } = useIntl();
  const { cacheSeed, deviatedLineItemsListFilters } = useCampaignStore() as CampaignsStore;

  const summaryCacheSeed = cacheSeed + JSON.stringify(deviatedLineItemsListFilters);
  const summaryFilters = buildDeviatedLineItemsRequestBody(
    deviatedLineItemsListFilters.advanceFilters,
    deviatedLineItemsListFilters.text
  );

  return (
    <div className="deviatedLineItemsPage">
      <header className="deviatedLineItemsPage__header">
        <h1 className="deviatedLineItemsPage__title">
          {formatMessage({ defaultMessage: 'Delivery Status', id: 'deviatedLineItems.page.title' })}
        </h1>
        <DeviatedLineItemsStats cacheSeed={summaryCacheSeed} filters={summaryFilters} />
        <div className="deviatedLineItemsPage__metrics">
          <DeviatedLineItemsCount cacheSeed={summaryCacheSeed} filters={summaryFilters} />
        </div>
      </header>
      <Main className="mainLayout mainLayout__campaigns">
        <div className="deviatedLineItemsPage__content">
          <DeviatedLineItemsTab />
        </div>
      </Main>
    </div>
  );
}

export default function DeviatedLineItemsPage() {
  const hasDeviatedLI = useFeatureUser('deviatedLI');
  const { user: userId = '' } = useGlobalStore(store => getSessionByKeys(store, ['user']));

  if (!hasDeviatedLI) {
    return null;
  }

  return (
    <Provider createStore={() => createStore(getPersistedCampaignsFiltersForUser(userId), userId)}>
      <DeviatedLineItemsPageContent />
    </Provider>
  );
}
